// import React, { useContext, useEffect, useState } from 'react'
// import { Flex, Flexed, Input, Label, Selectbox, Textauto } from '../../../utilities/Shared'
// import Sheet from './Sheet'
// import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
// import OptionForm from './OptionForm'
// import {Plus, X} from 'lucide-react'
// import { v4 as uuidv4 } from 'uuid';
// import EstContext from '../../../Context/EstContext'
// import Select from '../../../utilities/Select'
// import PaperSelect from '../../../utilities/PaperSelect'
// import Form from './Form'
// import CSVMapper from './CSVMapper'



// const FormSetup = ({form,setForms,option,item}) => {

//     const {info, setInfo,paperlist,forms} = useContext(EstContext)
  

// const addform = () => {
//  const deepCopyObj = JSON.parse(JSON.stringify(info.options[option].forms[0]));
//  deepCopyObj.itemid = uuidv4()
//  deepCopyObj.name =`Form ${info.options[option].forms.length + 1}`
//  const jj = {...info}
//  let h = [...jj.options[option].forms,deepCopyObj]
// jj.options[option].forms = h    
//     setInfo(jj) 
// }

// const removeform = (id) => {
//   const jj = {...info}
//   let h = jj.options[option].forms
//   let hh = h.filter(filt => filt.itemid !== id)
//   jj.options[option].forms = hh
// setInfo(jj)
// }

//   return (
//   <>

// <Tabs>
//  <TabList> 
//      <span style={{position:"relative",top:"10px",marginRight:"10px",textAlign:"left"}}  ><Plus color="green" size="24" strokeWidth={3} onClick={e => addform()}/></span>
//     {
//         item.forms?.map((item,index) => {
// return <Tab><div style={{fontSize:"calc(1rem + .2vw)"}}>{item.name}
// {
//     index > 0 ? <X size="20" strokeWidth={3} style={{position:"relative",right:"-7px",top:"6px"}} color="rgb(255,0,0,.6)" onClick={e => removeform(item.itemid)} /> : <X size="20" strokeWidth={3} style={{position:"relative",right:"-7px",top:"6px",visibility:"hidden"}} />
// }
// </div></Tab>
//         })
//     }
//     </TabList>
//     {
//         item?.forms.map((item,itemindex) => {
//         return    <TabPanel style={{color:"#418DA7"}}><Form item={item} index={itemindex} option={option}/></TabPanel>  
//         })
//     }
//      </Tabs>


// <br />
          
// {/* //////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}

//         <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />  <br />

        
//     <div>
  
//     </div>
//         </>


//   )
// }

// export default FormSetup




import React, { useContext, useEffect, useState } from 'react'
import { Flex, Flexed, Input, Label, Selectbox, Textauto } from '../../../utilities/Shared'
import Sheet from './Sheet'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import OptionForm from './OptionForm'
import {Plus, X} from 'lucide-react'
import { v4 as uuidv4 } from 'uuid';
import EstContext from '../../../Context/EstContext'
import Select from '../../../utilities/Select'
import PaperSelect from '../../../utilities/PaperSelect'
import Form from './Form'

const FormSetup = ({ option, item, minQuant, maxQuant }) => {

    const { info, setInfo } = useContext(EstContext)

    // NEW: Calculate for min and max quantities
    const [minResult, setMinResult] = useState(null);
    const [maxResult, setMaxResult] = useState(null);

    // This runs your existing Form logic for both smallest and largest quantity
    useEffect(() => {
        if (!minQuant || !maxQuant || !item?.forms) return;

        // TODO: Replace this with your actual calculation logic from <Form />
        // For now, this is a placeholder showing the structure
        console.log(`Calculating for Min Quantity: ${minQuant}`);
        console.log(`Calculating for Max Quantity: ${maxQuant}`);

        // Example: You will call the same calculation function here
        // const minCalc = calculateEstimate(item, minQuant);
        // const maxCalc = calculateEstimate(item, maxQuant);

        // setMinResult(minCalc);
        // setMaxResult(maxCalc);

    }, [minQuant, maxQuant, item]);

    const addform = () => {
        const deepCopyObj = JSON.parse(JSON.stringify(info.options[option].forms[0]));
        deepCopyObj.itemid = uuidv4()
        deepCopyObj.name = `Form ${info.options[option].forms.length + 1}`
        const jj = { ...info }
        let h = [...jj.options[option].forms, deepCopyObj]
        jj.options[option].forms = h
        setInfo(jj)
    }

    const removeform = (id) => {
        const jj = { ...info }
        let h = jj.options[option].forms
        let hh = h.filter(filt => filt.itemid !== id)
        jj.options[option].forms = hh
        setInfo(jj)
    }

    return (
        <>
            <Tabs>
                <TabList>
                    <span style={{ position: "relative", top: "10px", marginRight: "10px", textAlign: "left" }}>
                        <Plus color="green" size="24" strokeWidth={3} onClick={e => addform()} />
                    </span>
                    {item.forms?.map((formItem, index) => (
                        <Tab key={index}>
                            <div style={{ fontSize: "calc(1rem + .2vw)" }}>
                                {formItem.name}
                                {index > 0 ? (
                                    <X
                                        size="20"
                                        strokeWidth={3}
                                        style={{ position: "relative", right: "-7px", top: "6px" }}
                                        color="rgb(255,0,0,.6)"
                                        onClick={e => { e.stopPropagation(); removeform(formItem.itemid) }}
                                    />
                                ) : (
                                    <X size="20" strokeWidth={3} style={{ position: "relative", right: "-7px", top: "6px", visibility: "hidden" }} />
                                )}
                            </div>
                        </Tab>
                    ))}
                </TabList>

                {item?.forms.map((formItem, itemindex) => (
                    <TabPanel key={itemindex} style={{ color: "#418DA7" }}>
                        <Form 
                            item={formItem} 
                            index={itemindex} 
                            option={option}
                            minQuant={minQuant}     // ← pass down
                            maxQuant={maxQuant}     // ← pass down
                        />
                    </TabPanel>
                ))}
            </Tabs>

            <br /><br />

            {/* NEW: Min / Max Summary Section */}
            <div className="bg-teal-50 border border-teal-200 rounded-3xl p-6 mt-8">
                <h3 className="text-lg font-semibold text-teal-800 mb-4">Quick Cost Summary (Min & Max Quantities)</h3>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                        <div className="text-sm text-gray-500">Smallest Quantity</div>
                        <div className="text-3xl font-bold text-teal-700">{minQuant || '—'}</div>
                        {minResult && (
                            <div className="mt-2 text-lg">
                                Total: <span className="font-semibold">${minResult.total?.toFixed(2) || '—'}</span>
                            </div>
                        )}
                    </div>

                    <div>
                        <div className="text-sm text-gray-500">Largest Quantity</div>
                        <div className="text-3xl font-bold text-teal-700">{maxQuant || '—'}</div>
                        {maxResult && (
                            <div className="mt-2 text-lg">
                                Total: <span className="font-semibold">${maxResult.total?.toFixed(2) || '—'}</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default FormSetup
